import React from "react";

const ChevronDownIcon: React.FC<{ className?: string; color?: string }> = ({
  className,
  color = "#545454", // Default color is #545454
}) => (
  <svg
    className={className}
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.95451 0.704506L3.99998 3.65904L1.04542 0.704506L0.25 1.5L3.99998 5.25L7.75 1.5L6.95451 0.704506Z"
      fill={color}
    />
  </svg>
);

export default ChevronDownIcon;
